// src/pages/MS/MSU101F3.jsx
import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import SelectBox from "components/SelectBox/SelectBox";
import SwitchGroup from "components/Button/SwitchGroup";
import {postData} from "utils/TransactionUtil";


import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";


const MSU101F3 = ({handle_Close, comHandleClick_Save}) => {

    // useEffect(() => {
    // }, []);

    const [comHsptObj, setComHsptObj] = useState([]);
    const [comRoleObj, setComRoleObj] = useState([]);

    //form load
    useEffect(() => {
        //공통코드 조회
        getComDtlsData();
    }, []);

    useEffect(() => {

        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            if(checkEssential()){
                svcUserRegistration();
            }
        });
    }, [comHandleClick_Save]);




    const [userDtl, setUserDtl] = useState({
        lginId:'', userNm:'', userPw1:'', userPw2:'', userPwR:'', hsptCd:'', userType:'',
        hsptNm:'', mcdpCd:'', mcdpNm:'' , useYn:'', roleId:'', userDscr:''
    });


    /* Event ==================================================================================================== */
    const [isCheckId, setIsCheckId] = useState(false);

    //const [isAuthPass, setIsAuthPass] = useState("");

    const btnClick_checkId = () => {
        const idRegEx =  /^(?=.*[a-z])[a-z0-9_-]{6,20}$/;
        const validateId = (id) => {
            return idRegEx.test(id);
        };

        if(validateId(userDtl.lginId)){

            //toast({ type: 'info', message: 'ID체크가 완료되었습니다.'});
        }else{
            toast({ type: 'warning', message: 'ID규칙을 확인해주세요.'});
            return;
        }
        svcCheckDuplicateId();

    }

    function checkEssential() {
        let result = true;

        //패스워드 체크
        const idRegEx =  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,16}$/;
        const validatePw = (pw) => {
            return idRegEx.test(pw);
        };

        if(userDtl.hsptCd === null || userDtl.hsptCd === '' ) {
            toast({ type: 'warning', message: '기관을 선택하여 주세요.'});
            result = false;
        }else if(userDtl.roleId === null || userDtl.roleId === '' ) {
            toast({ type: 'warning', message: '역할을 선택하여 주세요.'});
            result = false;
        }else if(!validatePw(userDtl.userPw1)){
            result=false;
            toast({ type: 'warning', message: '패스워드 규칙을 확인해주세요.'});
        }else if(userDtl.userPw1 !== userDtl.userPw2){
            result=false;
            toast({ type: 'warning', message: '패스워드/확인값이 다릅니다.'});
        }else if(!isCheckId){
            result=false;
            toast({ type: 'warning', message: 'ID를 확인하여 주십시오.'});
        }else if(userDtl.userNm.length < 2){
            result=false;
            toast({ type: 'warning', message: '사용자명을 입력하여 주십시오.'});
        }else if(userDtl.useYn.length < 1){
            result=false;
            toast({ type: 'warning', message: '사용여부를 확인하여 주십시오.'});
        }



        return result;
    }



    /* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);

        //공통 역할정보
        const param2 = {comGrpCd:"ROLE_ID"}
        const resultData2 = await postData("/getComDtlsCd", param2);
        setComRoleObj(resultData2);
    }

    async function svcCheckDuplicateId() {

        let param = {
            lginId : userDtl.lginId
        }

        //사용자 ID 체크
        let result = await postData("/MSU/getUserIDChk", param);

        if(result > 0){
            setIsCheckId(false);
            toast({ type: 'warning', message: '이미 등록된 ID입니다.'});
        }else{
            setIsCheckId(true);
            toast({ type: 'info', message: 'ID체크가 완료되었습니다.'});
        }

    }


    async function svcUserRegistration() {

        //사용자 등록
        let result = await postData("/MSU/userRegistrationId", userDtl);
        if(result===1){
            toast({ type: 'info', message: '등록이 완료되었습니다.'});
        }

        handle_Close(result);

    }


    return(
        <>
            <div className={styleCom.main_wrap} style={{ marginBottom: "10px"}}>
                <Table variant='default' rowCnt={7} colSize={['30%', '70%']} rowSize={'56px'}>
                    <div>기관</div>
                    <div>
                        <SelectBox options={comHsptObj}
                                   valueKey="comnDtlsCd" labelKey="detlCdNm"
                                   value={userDtl.hsptCd}
                                   onChange={(val) => setUserDtl({...userDtl, hsptCd: val})}
                                   width={"64%"}
                        />
                    </div>
                    <div>역할</div>
                    <div>
                        <SelectBox options={comRoleObj}
                                   valueKey="comnDtlsCd" labelKey="detlCdNm"
                                   value={userDtl.roleId}
                                   onChange={(val) => setUserDtl({...userDtl, roleId: val})}
                                   width={"64%"}
                        />
                    </div>
                    <div>
                        <table>
                            <tbody>
                            <tr>
                                <td>사용자 ID</td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{color: "gray", fontSize: "12px"}}>
                                        6~20자(소문자 영문/숫자/'_', '-')
                                    </div>
                                </td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <div>
                        <InputUnitText type={"text"} maxLength={20} readOnly={isCheckId}
                                       value={userDtl.lginId}
                                       onChange={(value) => setUserDtl({...userDtl, lginId: value})}

                        />

                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnClick_checkId()}
                        >확인</Button>


                    </div>
                    <div>사용자명</div>
                    <div>
                        <InputUnitText type={"text"} maxLength={20}
                                       value={userDtl.userNm}
                                       onChange={(value) => setUserDtl({...userDtl, userNm: value})}/>
                    </div>
                    <div>사용여부</div>
                    <div>
                        <SwitchGroup
                            items={{"사용": "Y", "미사용": "N"}}
                            addStyle={{width: "108px", height: "40px"}}
                            value={userDtl.useYn}
                            onClick={(value) => setUserDtl({...userDtl, useYn: value})}/>
                    </div>
                    <div>패스워드</div>
                    <div>

                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userPw1}
                                       onChange={(value) => setUserDtl({...userDtl, userPw1: value})}/>
                        <div style={{color: "gray", fontSize: "12px"}}>
                            8~16자(영문/숫자/특수문자를 혼합하여 사용하십시오)
                        </div>
                    </div>
                    <div>패스워드 확인</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userPw2}
                                       onChange={(value) => setUserDtl({...userDtl, userPw2: value})}/>
                    </div>
                    <div>비고</div>
                    <div style={{height: "150px"}}>
                        <textarea
                            style={{height: "130px", width: "100%"}}
                            name="userDscr"
                            value={userDtl.userDscr}
                            onChange={e => setUserDtl({...userDtl, userDscr: e.target.value})}
                        />
                    </div>
                </Table>
            </div>
        </>
    )
}
export default MSU101F3;